import React, { useState } from "react";
import "./CareerApplicationForm.css";

export default function CareerApplicationForm() {
  const [form, setForm] = useState({
    name: "",
    location: "",
    email: "",
    phone: "",
    institution: "",
    resume: null,
    message: "",
    consent: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : type === "file" ? files[0] : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    alert("Application submitted!");
  };

  return (
    <section className="career-app-form-section">
      <h2 className="career-app-title">Application Form</h2>
      <div className="career-app-subtitle">
        Step into success — your career at VCNR starts here.<br />
        Apply now for current openings or share your interest in internships by filling out our form.
      </div>
      <form className="career-app-form" onSubmit={handleSubmit}>
        <div className="career-app-row">
          <input
            type="text"
            name="name"
            placeholder="Your Name *"
            value={form.name}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="location"
            placeholder="Your Location*"
            value={form.location}
            onChange={handleChange}
            required
          />
        </div>
        <div className="career-app-row">
          <input
            type="email"
            name="email"
            placeholder="Your Email *"
            value={form.email}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="phone"
            placeholder="Phone No *"
            value={form.phone}
            onChange={handleChange}
            required
          />
        </div>
        <div className="career-app-row">
          <input
            type="text"
            name="institution"
            placeholder="Your institution name *"
            value={form.institution}
            onChange={handleChange}
            required
          />
          <label className="career-app-upload-btn">
            {form.resume ? form.resume.name : "Upload Your Resume"}
            <input
              type="file"
              name="resume"
              accept=".pdf,.doc,.docx"
              onChange={handleChange}
              style={{ display: "none" }}
              required
            />
          </label>
        </div>
        <textarea
          name="message"
          placeholder="Write your message*"
          value={form.message}
          onChange={handleChange}
          required
        />
        <div className="career-app-row career-app-checkbox-row">
          <input
            type="checkbox"
            name="consent"
            checked={form.consent}
            onChange={handleChange}
            required
          />
          <span>
            By submitting this form, you acknowledge that VCNR may use your personal information for marketing communications as outlined in its privacy policy *
          </span>
        </div>

        <button className="career-app-submit-btn" type="submit">
          Submit
        </button>
      </form>
    </section>
  );
} 